import { render } from "./GroupForm.vue?vue&type=template&id=39f60d74&scoped=true"
import script from "./GroupForm.vue?vue&type=script&lang=js"
export * from "./GroupForm.vue?vue&type=script&lang=js"

import "./GroupForm.vue?vue&type=style&index=0&id=39f60d74&scoped=true&lang=css"

import exportComponent from "/var/www/html/lynkto-vlan-ticket-admin-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39f60d74"]])

export default __exports__